export const CREATE_PREVIEW_THUMBNAIL = 'CREATE_PREVIEW_THUMBNAIL';

export const SYNC_PREVIEW_THUMBNAIL = 'SYNC_PREVIEW_THUMBNAIL';

export const START_THUMBNAIL_GENERATION = 'START_THUMBNAIL_GENERATION';

export const END_THUMBNAIL_GENERATION = 'END_THUMBNAIL_GENERATION';
